import type { ApiClient } from './runtime/apiRuntime';
import { PollWeightsRequest } from './Api';
import { apiMutationOptions, BaseApiMutationOptions } from './apiMutationOptions';
import { apiQueryOptions, BaseApiQueryOptions } from './apiQueryOptions';

export const PollApi = {
    get: (webinarId: string, options?: BaseApiQueryOptions) => apiQueryOptions(['poll', 'get', webinarId], (api) => api.poll.get(webinarId), options),
    remove: (options?: BaseApiMutationOptions<ApiClient['poll']['remove']>) => apiMutationOptions((api) => api.poll.remove, options),
    edit: (options?: BaseApiMutationOptions<ApiClient['poll']['edit']>) => apiMutationOptions((api) => api.poll.edit, options),
    add: (options?: BaseApiMutationOptions<ApiClient['poll']['add']>) => apiMutationOptions((api) => api.poll.add, options),
    getVoteWeights: (data: PollWeightsRequest, options?: BaseApiQueryOptions) =>
        apiQueryOptions(['poll', 'getVoteWeights', data.webinarId, data.pollId], (api) => api.poll.getVoteWeights(data), options),
    setDefaultVoteWeight: (options?: BaseApiMutationOptions<ApiClient['poll']['setDefaultVoteWeight']>) =>
        apiMutationOptions((api) => api.poll.setDefaultVoteWeight, options),
    clearVoteWeights: (options?: BaseApiMutationOptions<ApiClient['poll']['clearVoteWeights']>) =>
        apiMutationOptions((api) => api.poll.clearVoteWeights, options),
    removeVoteWeight: (options?: BaseApiMutationOptions<ApiClient['poll']['removeVoteWeight']>) =>
        apiMutationOptions((api) => api.poll.removeVoteWeight, options),
    addVoteWeights: (options?: BaseApiMutationOptions<ApiClient['poll']['addVoteWeights']>) => apiMutationOptions((api) => api.poll.addVoteWeights, options),
    importVoteWeights: (options?: BaseApiMutationOptions<ApiClient['poll']['importVoteWeights']>) =>
        apiMutationOptions((api) => api.poll.importVoteWeights, options)
};
